import axios from "axios";

const createItemOthers = async (item_others) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/ItemOthers`, item_others)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllItemOthers = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/ItemOthers`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getItemOthers = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/ItemOthers/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editItemOthers = async (id, item_others) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/ItemOthers/${id}`, item_others)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteItemOthers = async (id, force) => {
  return axios
    .delete(`${process.env.REACT_APP_API_URL}/ItemOthers/${id}?force=${force}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const ItemOthersService = {
  createItemOthers,
  getAllItemOthers,
  getItemOthers,
  editItemOthers,
  deleteItemOthers
};

export default ItemOthersService;
